
// Mapbox token from the environment with a fallback to hardcoded value if not present
let tokenFromEnv = process.env.REACT_APP_MAPBOX_TOKEN;
let tokenFallback = "pk.eyJ1IjoiY2l2aWNtYXBwZXIiLCJhIjoiY2xnY3BoMno0MDF4aTNrcGpmNW5hY2hlbCJ9.N_64iyzh7nvNbY4an5GOpw"; //"pk.eyJ1IjoibWFwYm94IiwiYSI6ImNpejY4M29iazA2Z2gycXA4N2pmbDZmangifQ.-g_vE53SD2WrJ6tFX7QHmA";

export const MAPBOX_TOKEN = tokenFromEnv || tokenFallback;
console.log("Using Mapbox token: ", MAPBOX_TOKEN);